import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export interface Device {
  id: number;
  deviceId: string;
  lastLifeBit: string;
  isFaultActive: boolean;
  activeFaultCount: number;
  edmsFaultCount: number;
  affectedInstances: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private apiUrl = environment.apiBaseUrl + '/device'; // Deine API-URL

  constructor(private http: HttpClient) { }

  getDevices(): Observable<Device[]> {
    return this.http.get<Device[]>(`${this.apiUrl}/all`);
  }
}
